export default {
  baseStyle: {
    control: {
      _checked: {
        bg: 'primary.solid',
        borderColor: 'primary.solid',
        _hover: {
          bg: 'primary.emphasized',
          borderColor: 'primary.emphasized',
        },
      },
    },
    icon: {},
  },
}
